"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateModule = void 0;
class ValidateModule {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    cpf(cpf, agreementId) {
        return this.axiosInstance
            .post("/api/v1/check_cpf/", {
            cpf,
            agreement: agreementId,
        })
            .then(({ data }) => data);
    }
    promocode(promocode) {
        return this.axiosInstance
            .post("/api/v1/validate_promocode/", { promocode })
            .then(({ data }) => data);
    }
}
exports.ValidateModule = ValidateModule;
//# sourceMappingURL=validate.js.map